export interface PatientHistoryEntry {
  date: Date | null,
  description: string | null,
  studyUID: string | null,
  studyId: number | null,
  bookId: number | null,
  studyToken: string | null
  status: string | null
}

export namespace PatientHistoryEntry {
  export function sanitize(entry: PatientHistoryEntry): PatientHistoryEntry {
    return {
      date: (entry.date != null) ? new Date(entry.date) : null,
      description: entry.description,
      studyUID: entry.studyUID,
      studyId: (entry.studyId != null) ? +entry.studyId : null,
      bookId: (entry.bookId != null) ? +entry.bookId : null,
      studyToken: entry.studyToken,
      status: entry.status,
    }
  }

  export function sanitizeAll(entries: PatientHistoryEntry[]): PatientHistoryEntry[] {
    return entries.map(e => sanitize(e));
  }

  export function getExample(): PatientHistoryEntry[] {
    return [
      {
        date: new Date(1614923262027),
        bookId: 2,
        description: 'Book Mejorado MR',
        studyId: 2,
        studyToken: 'demoMR_STPLUS',
        studyUID: '2',
        status: "READY"
      },
      {
        date: new Date(1564923262027),
        bookId: 3,
        description: 'Book Mejorado CT',
        studyId: 3,
        studyToken: 'demoCT_STPLUS',
        studyUID: '3',
        status: "READY"
      },
      {
        date: new Date(1544923262027),
        bookId: 4,
        description: 'Book Mejorado MG',
        studyId: 4,
        studyToken: 'demoMG_STPLUS',
        studyUID: '4',
        status: "READY"
      },
      {
        date: new Date(1615923262027),
        bookId: 5,
        description: 'Book Dinámico CT',
        studyId: 5,
        studyToken: 'demoCT_D',
        studyUID: '5',
        status: "READY"
      },
      {
        date: new Date(1615923262027),
        bookId: 6,
        description: 'Book Dinámico MR',
        studyId: 6,
        studyToken: 'demoMR_D',
        studyUID: '6',
        status: "READY"
      }
    ]
  }
}